import StripeElementsForm from '@/components/forms/cardDetails/StripeElementsForm';
import StripePaymentRequestButton from '@/components/forms/cardDetails/StripePaymentRequestButton';
import applePay from '@/assets/images/icons/apple-pay.svg';
import gPay from '@/assets/images/icons/gpay.svg';
import masterCard from '@/assets/images/logos/logo-MasterCard.svg';
import visaCard from '@/assets/images/logos/logo-Visa.png';

const i18n = require('@/i18n').default;

function detectBrowser() {
    let userAgent = navigator.userAgent;
    if (userAgent.match(/chrome|chromium|crios/i)) {
        return 'Chrome';
    } else if (userAgent.match(/firefox|fxios/i)) {
        return 'Firefox';
    } else if (userAgent.match(/safari/i)) {
        return 'Safari';
    } else if (userAgent.match(/opr\//i)) {
        return 'Opera';
    } else if (userAgent.match(/edg/i)) {
        return 'Edge';
    } else if ((userAgent.indexOf('MSIE') !== -1) || (!!document.documentMode === true)) {
        return 'IE';
    } else {
        return 'Unknown';
    }
}

const detectedBrowser = detectBrowser();

function getWalletIcon() {
    if (detectedBrowser === 'Chrome') return gPay;
    if (detectedBrowser === 'Safari') return applePay;
}

function getWalletCopy() {
    if (detectedBrowser === 'Chrome') return i18n.t('GOOGLE_PAY');
    if (detectedBrowser === 'Safari') return i18n.t('APPLE_PAY');
}

export const payments = [
    {
        key: 'wallet',
        component: StripePaymentRequestButton,
        icon: getWalletIcon(),
        label: getWalletCopy(),
        val: 'wallet',
        isSelected: false,
        enabled: process.env.VUE_APP_ENABLE_STRIPE_WALLET === 'true',
    },
    {
        key: 'card',
        component: StripeElementsForm,
        icon: null,
        label: i18n.t('CARD_OPTION'),
        val: 'card',
        isSelected: true,
        enabled: true,
    },
];

export const paymentMethods = [
    {
        name: 'MasterCard',
        asset: masterCard,
        height: '30px',
        key: 'card',
    },
    {
        name: 'VISA Card',
        asset: visaCard,
        height: '30px',
        key: 'card',
    },
    {
        name: 'Apple Pay',
        asset: applePay,
        height: '20px',
        key: 'wallet',
    },
    {
        name: 'Google Pay',
        asset: gPay,
        height: '20px',
        key: 'wallet',
    },
];
